import { css } from '@/styled-system/css';

export const calendarDayOfWeekStyles = css.raw({
  textStyle: 'body-sm-bold',
  display: 'grid',
  placeItems: 'center',
  paddingBlockEnd: 'Calendar.DayOfWeek.padding.bottom',
  borderBottomStyle: 'solid',
  borderBottomColor: 'Calendar.DayOfWeek.border.default',
  borderBottomWidth: 'Calendar.DayOfWeek.default',
});
